<ng-container *ngFor="let error of errors">
  <span
    ion-color-danger
    class="error-message text-danger"
    *ngIf="(item.hasError(error.type) || item.errors?.minLength) && (item.dirty || item.touched)"
  >
    {{ error.message }}
  </span>
</ng-container>
